module.exports = __webpack_public_path__ + "static/media/checkmark.336237a1.svg";